/* @import '../../global/app.css'; */
@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.content-top {
  @apply flex flex-col  items-center justify-center;
}


.large-image-block-background {
  @apply absolute -z-10 top-0 left-0 w-full h-5/6 bg-cover bg-center rounded-xl;
}

.large-image-block-container {
  @apply flex flex-col items-center relative  justify-center  gap-32px md:gap-64px;
}

.large-image-block-content {
  @apply mx-auto max-w-[700px] text-center;
}

.large-image-block-asset-container {
  @apply w-full h-full relative rounded-xl overflow-hidden;
}

.large-image-block-asset-container iframe {
  @apply w-full h-full aspect-video rounded-xl max-h-[900px];
  aspect-ratio: 2 / 1;
}

.large-image-block-asset-container img {
  @apply w-full overflow-hidden rounded-xl  object-cover max-h-[900px];
  aspect-ratio: 2 / 1;
}

/* Animations */
@keyframes fade-in {
  0% {
    opacity: 0.40;
  }
  100% {
    opacity: 0;
  }
}

.overlay1, .overlay2 {
  @apply bg-white absolute w-full h-full top-0 left-0 z-10 opacity-50;
  /* filter: grayscale(100%); */
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 200ms;
}

.large-image-block-container.animate .overlay1 {
    animation-name: fade-in;
    animation-delay: 0.15s;
  }
  
  .large-image-block-container.animate .overlay2 {
    animation-name: fade-in;
    animation-delay: 0.3s;
  }
